import React from "react";
import styled from "styled-components";
import Select from '../../dev/Select'
import Title from './Title'
const categories = [
    {
        category: "訂閱數",
        categoryContent: `subscribers`,
        ga: "ga_subscribers"
    },
    {
        category: "日訂閱數",
        categoryContent: `daily_subscribers`,
        ga: "ga_rank_daily_subscribers"
    },
    {
        category: "月訂閱數",
        categoryContent: `monthly_subscribers`,
        ga: "ga_rank_monthly_subscribers"
    },
    {
        category: "月訂閱成長率",
        categoryContent: `monthly_subscriptions_growth`,
        ga: "ga_rank_monthly_subscriptions_growth"
    },
    {
        category: "月觀看數",
        categoryContent: `monthly_views`,
        ga: "ga_rank_monthly_views"
    },
    {
        category: "月觀看成長率",
        categoryContent: `monthly_views_growth`,
        ga: "ga_rank_monthly_views_growth"
    },
    {
        category: "近20支平均觀看數",
        categoryContent: "20_avg_views",
        ga: "ga_rank_20_views"
    },
    {
        category: "近20支平均互動率",
        categoryContent: "20_avg_engage",
        ga: "ga_rank_20_engage"
    },
    {
        category: "rank_more",
        categoryContent: "rank_more",
        ga: "ga_rank_more"
    }
];
const Category = ({categoryValue, categoryContent, toggleCategory, messages}) => (
    <Container>
        <Title>{messages.category}：</Title>
        {window.matchMedia("(max-width: 665px)").matches // 是手機版嗎
            ? <StyledSelect
                id='CategorySelect'
                onChange={(e) => toggleCategory(e.value, e.categoryContent)}
                options={categories.map(i => {return {value: i.category, label: messages[i.categoryContent], categoryContent: i.categoryContent}})}
                placeholder={messages[categoryContent]}
                isSearchable={false}
            /> 
            : <div>
                {categories.map(i => {
                const { category, categoryContent, ga } = i;
                return (
                    <CategoryButton
                        id={ga}
                        isCategory={category === categoryValue}
                        onClick={() => toggleCategory(category,categoryContent)} /*isLast={category ==='近20支平均互動率'}*/
                    >
                        {messages[categoryContent]}
                    </CategoryButton>
                )})}
            </div>
        }
    </Container>
)
export default Category

const Container = styled.div`
    display: flex;
    @media (max-width: 900px) {
        align-items: center;
    }
`
const CategoryButton = styled.div`
    display: inline-flex;
    height: 24px;
    padding: 0 8px;
    margin-right: ${props => (props.isLast ? "0px" : "5px")};
    margin-bottom: 5px;
    border-radius: 24px;
    border: ${props =>
        props.isCategory ? "solid 0.5px transparent" : "solid 0.5px #979797"};
    background-color: ${props => (props.isCategory ? "#de0606" : "#fff")};
    font-size: 14px;
    font-weight: 300;
    color: ${props => (props.isCategory ? "#fff" : "#979797")};
    cursor: pointer;
`;
const StyledSelect = styled(Select)`
    z-index: 5000;
    @media (max-width: 900px) {
        width: 100%;
    }
`


// WEBPACK FOOTER //
// ./src/Ranking/RankCondition/CategorySearch.js